export const stocks = [
  {
    name: "Mrf Limited",
    url3: "https://dhan.co/stocks/mrf-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMRF",
    nsecode: "MRF",
    bsecode: "500290",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2277:MRF",
    atToken: "NSE_MRF"
  },
  {
    name: "Bosch Limited",
    url3: "https://dhan.co/stocks/bosch-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABOSCHLTD",
    nsecode: "BOSCHLTD",
    bsecode: "500530",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2181:Bosch",
    atToken: "NSE_BOSCHLTD"
  },
  {
    name: "Bajaj Auto Limited",
    url3: "https://dhan.co/stocks/bajaj-auto-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABAJAJ_AUTO",
    nsecode: "BAJAJ-AUTO",
    bsecode: "532977",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE16669:Bajaj Auto",
    atToken: "NSE_BAJAJAUTO"
  },
  {
    name: "Eicher Motors Limited",
    url3: "https://dhan.co/stocks/eicher-motors-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AEICHERMOT",
    nsecode: "EICHERMOT",
    bsecode: "505200",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE910:Eicher Motors",
    atToken: "NSE_EICHERMOT"
  },
  {
    name: "Hero Motocorp Limited",
    url3: "https://dhan.co/stocks/hero-motocorp-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHEROMOTOCO",
    nsecode: "HEROMOTOCO",
    bsecode: "500182",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1348:Hero Motocorp",
    atToken: "NSE_HEROMOTOCO"
  },
  {
    name: "Escorts Limited",
    url3: "https://dhan.co/stocks/escorts-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AESCORTS",
    nsecode: "ESCORTS",
    bsecode: "500495",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE958:Escorts Kubota",
    atToken: "NSE_ESCORTS"
  },
  {
    name: "Mahindra & Mahindra Limited",
    url3: "https://dhan.co/stocks/mahindra-mahindra-ltd-share-price/",
    url: "https://www.tradingview.com/chart/?symbol=NSE%3AM%26M",
    nsecode: "M&M",
    bsecode: "500520",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2031:Mahindra & Mahindra",
    atToken: "NSE_MM"
  },
  {
    name: "Balkrishna Industries Limited",
    url3: "https://dhan.co/stocks/balkrishna-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABALKRISIND",
    nsecode: "BALKRISIND",
    bsecode: "502355",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE335:Balkrishna Industries",
    atToken: "NSE_BALKRISIND"
  },
  {
    name: "Tata Motors Limited",
    url3: "https://dhan.co/stocks/tata-motors-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATAMOTORS",
    nsecode: "TATAMOTORS",
    bsecode: "500570",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3456:Tata Motors",
    atToken: "NSE_TATAMOTORS"
  },
  {
    name: "Sona BLW Precision Forgings Ltd",
    url3: "https://dhan.co/stocks/sona-blw-precision-forgings-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASONACOMS",
    nsecode: "SONACOMS",
    bsecode: "543300",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4684:Sona BLW Precision Forgings",
    atToken: "NSE_SONACOMS"
  },
  {
    name: "Apollo Tyres Limited",
    url3: "https://dhan.co/stocks/apollo-tyres-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAPOLLOTYRE",
    nsecode: "APOLLOTYRE",
    bsecode: "500877",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE163:Apollo Tyres",
    atToken: "NSE_APOLLOTYRE"
  },
  {
    name: "Exide Industries Limited",
    url3: "https://dhan.co/stocks/exide-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AEXIDEIND",
    nsecode: "EXIDEIND",
    bsecode: "500086",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE676:Exide Industries",
    atToken: "NSE_EXIDEIND"
  },
  {
    name: "Ashok Leyland Limited",
    url3: "https://dhan.co/stocks/ashok-leyland-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AASHOKLEY",
    nsecode: "ASHOKLEY",
    bsecode: "500477",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE212:Ashok Leyland",
    atToken: "NSE_ASHOKLEY"
  },
  {
    name: "Motherson Sumi Systems Limited",
    url3: "https://dhan.co/stocks/motherson-sumi-systems-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMOTHERSON",
    nsecode: "MOTHERSON",
    bsecode: "517334",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE25510:SAMVARDHANA MOTHERSON INT",
    atToken: "NSE_MOTHERSON"
  },
  {
    name: "Maruti Suzuki India Limited",
    url3: "https://dhan.co/stocks/maruti-suzuki-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMARUTI",
    nsecode: "MARUTI",
    bsecode: "532500",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10999:Maruti Suzuki",
    atToken: "NSE_MARUTI"
  },
  {
    name: "Hindustan Aeronautics Ltd",
    url3: "https://dhan.co/stocks/hal-hindustan-aeronautics-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHAL",
    nsecode: "HAL",
    bsecode: "541154",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2303:Hindustan Aeronautics",
    atToken: "NSE_HAL"
  },
  {
    name: "Tvs Motor Company Limited",
    url3: "https://dhan.co/stocks/tvs-motors-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATVSMOTOR",
    nsecode: "TVSMOTOR",
    bsecode: "532343",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE8479:TVS Motors",
    atToken: "NSE_TVSMOTOR"
  },
  {
    name: "Titagarh Rail Systems Ltd",
    url3: "https://dhan.co/stocks/titagarh-wagons-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATITAGARH",
    nsecode: "TITAGARH",
    bsecode: "532966",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15414:Titagarh Rail Systems"
  },
  {
    name: "Acc Limited",
    url3: "https://dhan.co/stocks/acc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AACC",
    nsecode: "ACC",
    bsecode: "500410",
    sector: "CEMENT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE22:ACC",
    atToken: "NSE_ACC"
  },
  {
    name: "Ultratech Cement Limited",
    url3: "https://dhan.co/stocks/ultratech-cement-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AULTRACEMCO",
    nsecode: "ULTRACEMCO",
    bsecode: "532538",
    sector: "CEMENT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11532:UltraTech Cement",
    atToken: "NSE_ULTRACEMCO"
  },
  {
    name: "Jk Cement Limited",
    url3: "https://dhan.co/stocks/jk-cement-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AJKCL",
    nsecode: "JKCEMENT",
    bsecode: "532644",
    sector: "CEMENT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13270:JK Cement",
    atToken: "NSE_JKCEMENT"
  },
  {
    name: "Dalmia Bharat Limited",
    url3: "https://dhan.co/stocks/dalmia-bharat-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADALBHARAT",
    nsecode: "DALBHARAT",
    bsecode: "533309",
    sector: "CEMENT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE8075:Dalmia Bharat",
    atToken: "NSE_DALBHARAT"
  },
  {
    name: "Ambuja Cements Limited",
    url3: "https://dhan.co/stocks/ambuja-cements-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAMBUJACEM",
    nsecode: "AMBUJACEM",
    bsecode: "500425",
    sector: "CEMENT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1270:Ambuja Cements",
    atToken: "NSE_AMBUJACEM"
  },
  {
    name: "Shree Cements Limited",
    url3: "https://dhan.co/stocks/shree-cement-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASHREECEM",
    nsecode: "SHREECEM",
    bsecode: "500387",
    sector: "CEMENT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3103:Shree Cement",
    atToken: "NSE_SHREECEM"
  },
  {
    name: "The Ramco Cements Limited",
    url3: "https://dhan.co/stocks/ramco-cements-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ARAMCOCEM",
    nsecode: "RAMCOCEM",
    bsecode: "500260",
    sector: "CEMENT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2043:Ramco Cements",
    atToken: "NSE_RAMCOCEM"
  },
  {
    name: "Srf Limited",
    url3: "https://dhan.co/stocks/srf-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASRF",
    nsecode: "SRF",
    bsecode: "503806",
    sector: "COMMODITIES",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3273:SRF",
    atToken: "NSE_SRF"
  },
  {
    name: "Solar Industries India Limited",
    url3: "https://dhan.co/stocks/solar-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASOLARINDS",
    nsecode: "SOLARINDS",
    bsecode: "532725",
    sector: "COMMODITIES",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13332:Solar Industries"
  },
  {
    name: "Tata Chemicals Limited",
    url3: "https://dhan.co/stocks/tata-chemicals-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATACHEM",
    nsecode: "TATACHEM",
    bsecode: "500770",
    sector: "COMMODITIES",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3405:Tata Chemicals",
    atToken: "NSE_TATACHEM"
  },
  {
    name: "Berger Paints (i) Limited",
    url3: "https://dhan.co/stocks/berger-paints-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABERGEPAINT",
    nsecode: "BERGEPAINT",
    bsecode: "509480",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE404:Berger Paints",
    atToken: "NSE_BERGEPAINT"
  },
  {
    name: "Crompton Greaves Consumer Electricals Limited",
    url3: "https://dhan.co/stocks/crompton-greaves-consumer-electricals-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACROMPTON",
    nsecode: "CROMPTON",
    bsecode: "539876",
    sector: "COMMODITIES",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17094:Crompton Greaves",
    atToken: "NSE_CROMPTON"
  },
  {
    name: "Chambal Fertilizers & Chemicals Limited",
    url3: "https://dhan.co/stocks/chambal-fertilisers-chemicals-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACHAMBLFERT",
    nsecode: "CHAMBLFERT",
    bsecode: "500085",
    sector: "COMMODITIES",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE637:Chambal Fertilisers & Chemicals",
    atToken: "NSE_CHAMBLFERT"
  },
  {
    name: "Pidilite Industries Limited",
    url3: "https://dhan.co/stocks/pidilite-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APIDILITIND",
    nsecode: "PIDILITIND",
    bsecode: "500331",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2664:Pidilite Industries",
    atToken: "NSE_PIDILITIND"
  },
  {
    name: "Asian Paints Limited",
    url3: "https://dhan.co/stocks/asian-paints-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AASIANPAINT",
    nsecode: "ASIANPAINT",
    bsecode: "500820",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE236:Asian Paints",
    atToken: "NSE_ASIANPAINT"
  },
  {
    name: "Coromandel International Limited",
    url3: "https://dhan.co/stocks/coromandel-international-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACOROMANDEL",
    nsecode: "COROMANDEL",
    bsecode: "506395",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE739:Coromandel International"
  },
  {
    name: "Voltas Limited",
    url3: "https://dhan.co/stocks/voltas-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AVOLTAS",
    nsecode: "VOLTAS",
    bsecode: "500575",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3718:Voltas",
    atToken: "NSE_VOLTAS"
  },
  {
    name: "Havells India Limited",
    url3: "https://dhan.co/stocks/havells-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHAVELLS",
    nsecode: "HAVELLS",
    bsecode: "517354",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE9819:Havells",
    atToken: "NSE_HAVELLS"
  },
  {
    name: "Astral Poly Technik Limited",
    url3: "https://dhan.co/stocks/astral-poly-technik-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AASTRAL",
    nsecode: "ASTRAL",
    bsecode: "532830",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14418:Astral",
    atToken: "NSE_ASTRAL"
  },
  {
    name: "Godrej Consumer Products Limited",
    url3: "https://dhan.co/stocks/godrej-consumer-products-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGODREJCP",
    nsecode: "GODREJCP",
    bsecode: "532424",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10099:Godrej Consumer Products",
    atToken: "NSE_GODREJCP"
  },
  {
    name: "TATA Consumer Products Ltd",
    url3: "https://dhan.co/stocks/tata-consumer-products-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATACONSUM",
    nsecode: "TATACONSUM",
    bsecode: "500800",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3432:Tata Consumer Products",
    atToken: "NSE_TATACONSUM"
  },
  {
    name: "Upl Limited",
    url3: "https://dhan.co/stocks/upl-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AUPL",
    nsecode: "UPL",
    bsecode: "512070",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11287:UPL",
    atToken: "NSE_UPL"
  },
  {
    name: "Aarti Industries Limited",
    url3: "https://dhan.co/stocks/aarti-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAARTIIND",
    nsecode: "AARTIIND",
    bsecode: "524208",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE7:Aarti Industries",
    atToken: "NSE_AARTIIND"
  },
  {
    name: "Titan Company Limited",
    url3: "https://dhan.co/stocks/titan-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATITAN",
    nsecode: "TITAN",
    bsecode: "500114",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3506:Titan",
    atToken: "NSE_TITAN"
  },
  {
    name: "Torrent Power Limited",
    url3: "https://dhan.co/stocks/torrent-power-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATORNTPOWER",
    nsecode: "TORNTPOWER",
    bsecode: "532779",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13786:Torrent Power"
  },
  {
    name: "Indian Renewable Energy Development Agency Ltd",
    url3: "https://dhan.co/stocks/ireda-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIREDA",
    nsecode: "IREDA",
    bsecode: "544026",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE20261:IREDA"
  },
  {
    name: "Adani Green Energy Ltd",
    url3: "https://dhan.co/stocks/adani-green-energy-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AADANIGREEN",
    nsecode: "ADANIGREEN",
    bsecode: "541450",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3563:Adani Green Energy",
    atToken: "NSE_ADANIGREEN"
  },
  {
    name: "CG Power and Industrial Solutions Ltd",
    url3: "https://dhan.co/stocks/cg-power-and-industrial-solutions-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACGPOWER",
    nsecode: "CGPOWER",
    bsecode: "500093",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE760:CG Power & Industrial Solutions",
    atToken: "NSE_CGPOWER"
  },
  {
    name: "Jsw Energy Limited",
    url3: "https://dhan.co/stocks/jsw-energy-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AJSWENERGY",
    nsecode: "JSWENERGY",
    bsecode: "533148",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17869:JSW Energy",
    atToken: "NSE_JSWENERGY"
  },
  {
    name: "Ntpc Limited",
    url3: "https://dhan.co/stocks/ntpc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANTPC",
    nsecode: "NTPC",
    bsecode: "532555",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11630:NTPC",
    atToken: "NSE_NTPC"
  },
  {
    name: "Power Grid Corporation Of India Limited",
    url3: "https://dhan.co/stocks/power-grid-corporation-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APOWERGRID",
    nsecode: "POWERGRID",
    bsecode: "532898",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14977:Power Grid Corporation of India",
    atToken: "NSE_POWERGRID"
  },
  {
    name: "Cesc Limited",
    url3: "https://dhan.co/stocks/cesc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACESC",
    nsecode: "CESC",
    bsecode: "500084",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE628:CESC",
    atToken: "NSE_CESC"
  },
  {
    name: "Indian Energy Exchange Ltd",
    url3: "https://dhan.co/stocks/indian-energy-exchange-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIEX",
    nsecode: "IEX",
    bsecode: "540750",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE220:Indian Energy Exchange",
    atToken: "NSE_IEX"
  },
  {
    name: "Sjvn Limited",
    url3: "https://dhan.co/stocks/sjvn-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASJVN",
    nsecode: "SJVN",
    bsecode: "533206",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18883:SJVN",
    atToken: "NSE_SJVN"
  },
  {
    name: "Nhpc Limited",
    url3: "https://dhan.co/stocks/nhpc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANHPC",
    nsecode: "NHPC",
    bsecode: "533098",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17400:NHPC",
    atToken: "NSE_NHPC"
  },
  {
    name: "Adani Energy Solutions Ltd",
    url3: "https://dhan.co/stocks/adani-transmission-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AADANIENSOL",
    nsecode: "ADANIENSOL",
    bsecode: "539254",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10217:Adani Energy Solutions",
    atToken: "NSE_ADANIENSOL"
  },
  {
    name: "Tata Power Company Limited",
    url3: "https://dhan.co/stocks/tata-power-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATAPOWER",
    nsecode: "TATAPOWER",
    bsecode: "500400",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3426:Tata Power",
    atToken: "NSE_TATAPOWER"
  },
  {
    name: "Cummins India Limited",
    url3: "https://dhan.co/stocks/cummins-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACUMMINSIND",
    nsecode: "CUMMINSIND",
    bsecode: "500480",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1901:Cummins",
    atToken: "NSE_CUMMINSIND"
  },
  {
    name: "Mahanagar Gas Limited",
    url3: "https://dhan.co/stocks/mahanagar-gas-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMGL",
    nsecode: "MGL",
    bsecode: "539957",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17534:Mahanagar Gas",
    atToken: "NSE_MGL"
  },
  {
    name: "Reliance Industries Limited",
    url3: "https://dhan.co/stocks/reliance-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ARELIANCE",
    nsecode: "RELIANCE",
    bsecode: "500325",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2885:Reliance Industries",
    atToken: "NSE_RELIANCE"
  },
  {
    name: "Gujarat Gas Limited",
    url3: "https://dhan.co/stocks/gujarat-gas-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGUJGASLTD",
    nsecode: "GUJGASLTD",
    bsecode: "539336",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10599:Gujarat Gas"
  },
  {
    name: "Oil India Limited",
    url3: "https://dhan.co/stocks/oil-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AOIL",
    nsecode: "OIL",
    bsecode: "533106",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17438:Oil India",
    atToken: "NSE_OIL"
  },
  {
    name: "Indraprastha Gas Limited",
    url3: "https://dhan.co/stocks/indraprastha-gas-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIGL",
    nsecode: "IGL",
    bsecode: "532514",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11262:Indraprastha Gas",
    atToken: "NSE_IGL"
  },
  {
    name: "Petronet Lng Limited",
    url3: "https://dhan.co/stocks/petronet-lng-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APETRONET",
    nsecode: "PETRONET",
    bsecode: "532522",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11351:Petronet LNG",
    atToken: "NSE_PETRONET"
  },
  {
    name: "Oil & Natural Gas Corporation Limited",
    url3: "https://dhan.co/stocks/oil-natural-gas-corporation-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AONGC",
    nsecode: "ONGC",
    bsecode: "500312",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2475:Oil & Natural Gas Corporation",
    atToken: "NSE_ONGC"
  },
  {
    name: "Indian Oil Corporation Limited",
    url3: "https://dhan.co/stocks/indian-oil-corporation-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIOC",
    nsecode: "IOC",
    bsecode: "530965",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1624:Indian Oil Corporation",
    atToken: "NSE_IOC"
  },
  {
    name: "Adani Total Gas Ltd",
    url3: "https://dhan.co/stocks/adani-gas-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AATGL",
    nsecode: "ATGL",
    bsecode: "542066",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE6066:Adani Total Gas",
    atToken: "NSE_ATGL"
  },
  {
    name: "Hindustan Petroleum Corporation Limited",
    url3: "https://dhan.co/stocks/hindustan-petroleum-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHINDPETRO",
    nsecode: "HINDPETRO",
    bsecode: "500104",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1406:Hindustan Petroleum",
    atToken: "NSE_HINDPETRO"
  },
  {
    name: "Bharat Petroleum Corporation Limited",
    url3: "https://dhan.co/stocks/bharat-petroleum-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABPCL",
    nsecode: "BPCL",
    bsecode: "500547",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE526:Bharat Petroleum",
    atToken: "NSE_BPCL"
  },
  {
    name: "Gail (india) Limited",
    url3: "https://dhan.co/stocks/gail-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGAIL",
    nsecode: "GAIL",
    bsecode: "532155",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4717:GAIL",
    atToken: "NSE_GAIL"
  },
  {
    name: "Bajaj Finance Limited",
    url3: "https://dhan.co/stocks/bajaj-finance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABAJFINANCE",
    nsecode: "BAJFINANCE",
    bsecode: "500034",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE317:Bajaj Finance",
    atToken: "NSE_BAJFINANCE"
  },
  {
    name: "BSE (Bombay stock exchange)",
    url3: "https://dhan.co/stocks/bse-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABSE",
    nsecode: "BSE",
    bsecode: "20",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE19585:BSE",
    atToken: "NSE_BSE"
  },
  {
    name: "HDFC Asset Management Company Ltd",
    url3: "https://dhan.co/stocks/hdfc-asset-management-company-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHDFCAMC",
    nsecode: "HDFCAMC",
    bsecode: "541729",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4244:HDFC AMC",
    atToken: "NSE_HDFCAMC"
  },
  {
    name: "Muthoot Finance Limited",
    url3: "https://dhan.co/stocks/muthoot-finance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMUTHOOTFIN",
    nsecode: "MUTHOOTFIN",
    bsecode: "533398",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE23650:Muthoot Finance",
    atToken: "NSE_MUTHOOTFIN"
  },
  {
    name: "Central Depository Services Ltd",
    url3: "https://dhan.co/stocks/central-depository-services-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACDSL",
    nsecode: "CDSL",
    bsecode: "",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE21174:CDSL",
    atToken: "NSE_CDSL"
  },
  {
    name: "Bajaj Finserv Limited",
    url3: "https://dhan.co/stocks/bajaj-finserv-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABAJAJFINSV",
    nsecode: "BAJAJFINSV",
    bsecode: "532978",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE16675:Bajaj Finserv",
    atToken: "NSE_BAJAJFINSV"
  },
  {
    name: "Iifl Holdings Limited",
    url3: "https://dhan.co/stocks/iifl-finance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIIFL",
    nsecode: "IIFL",
    bsecode: "532636",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11809:IIFL Finance"
  },
  {
    name: "Max Financial Services Limited",
    url3: "https://dhan.co/stocks/max-financial-services-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMFSL",
    nsecode: "MFSL",
    bsecode: "500271",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2142:Max Financial Services",
    atToken: "NSE_MFSL"
  },
  {
    name: "Piramal Enterprises Limited",
    url3: "https://dhan.co/stocks/piramal-enterprises-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APEL",
    nsecode: "PEL",
    bsecode: "500302",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2412:Piramal Enterprises",
    atToken: "NSE_PEL"
  },
  {
    name: "Can Fin Homes Limited",
    url3: "https://dhan.co/stocks/can-fin-homes-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACANFINHOME",
    nsecode: "CANFINHOME",
    bsecode: "511196",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE583:Can Fin Homes"
  },
  {
    name: "Lic Housing Finance Limited",
    url3: "https://dhan.co/stocks/lic-housing-finance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALICHSGFIN",
    nsecode: "LICHSGFIN",
    bsecode: "500253",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1997:LIC Housing Finance",
    atToken: "NSE_LICHSGFIN"
  },
  {
    name: "Rural Electrification Corporation Limited",
    url3: "https://dhan.co/stocks/rural-electrification-corporation-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ARECLTD",
    nsecode: "RECLTD",
    bsecode: "532955",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15355:REC",
    atToken: "NSE_RECLTD"
  },
  {
    name: "Power Finance Corporation Limited",
    url3: "https://dhan.co/stocks/power-finance-corporation-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APFC",
    nsecode: "PFC",
    bsecode: "532810",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14299:Power Finance Corporation",
    atToken: "NSE_PFC"
  },
  {
    name: "Poonawalla Fincorp Ltd",
    url3: "https://dhan.co/stocks/poonawalla-fincorp-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APOONAWALLA",
    nsecode: "POONAWALLA",
    bsecode: "524000",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11403:Poonawalla Fincorp",
    atToken: "NSE_POONAWALLA"
  },
  {
    name: "Jio Financial Services Ltd",
    url3: "https://dhan.co/stocks/jio-financial-services-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AJIOFIN",
    nsecode: "JIOFIN",
    bsecode: "20712",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18143:Jio Financial Services",
    atToken: "NSE_JIOFIN"
  },
  {
    name: "Mahindra & Mahindra Financial Services Limited",
    url3: "https://dhan.co/stocks/mahindra-mahindra-financial-services-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AM%26MFIN",
    nsecode: "M&MFIN",
    bsecode: "532720",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13285:M&M Financial Services",
    atToken: "NSE_MMFIN"
  },
  {
    name: "Manappuram Finance Limited",
    url3: "https://dhan.co/stocks/manappuram-finance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMANAPPURAM",
    nsecode: "MANAPPURAM",
    bsecode: "531213",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE19061:Manappuram Finance",
    atToken: "NSE_MANAPPURAM"
  },
  {
    name: "Aditya Birla Capital Ltd",
    url3: "https://dhan.co/stocks/aditya-birla-capital-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AABCAPITAL",
    nsecode: "ABCAPITAL",
    bsecode: "540691",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE21614:Aditya Birla Capital",
    atToken: "NSE_ABCAPITAL"
  },
  {
    name: "Multi Commodity Exchange Of India Limited",
    url3: "https://dhan.co/stocks/multi-commodity-exchange-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMCX",
    nsecode: "MCX",
    bsecode: "534091",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE31181:MCX",
    atToken: "NSE_MCX"
  },
  {
    name: "Shriram Finance Ltd",
    url3: "https://dhan.co/stocks/shriram-transport-finance-company-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASHRIRAMFIN",
    nsecode: "SHRIRAMFIN",
    bsecode: "511218",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4306:Shriram Finance",
    atToken: "NSE_SHRIRAMFIN"
  },
  {
    name: "Angel One Ltd",
    url3: "https://dhan.co/stocks/angel-broking-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AANGELONE",
    nsecode: "ANGELONE",
    bsecode: "543235",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE324:Angel One",
    atToken: "NSE_ANGELONE"
  },
  {
    name: "ICICI Lombard General Insurance Company Ltd",
    url3: "https://dhan.co/stocks/icici-lombard-general-insurance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AICICIGI",
    nsecode: "ICICIGI",
    bsecode: "540716",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE21770:ICICI Lombard General Insurance",
    atToken: "NSE_ICICIGI"
  },
  {
    name: "SBI Life Insurance Company Ltd",
    url3: "https://dhan.co/stocks/sbi-life-insurance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASBILIFE",
    nsecode: "SBILIFE",
    bsecode: "540719",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE21808:SBI Life Insurance",
    atToken: "NSE_SBILIFE"
  },
  {
    name: "Cholamandalam Investment And Finance Company Limited",
    url3: "https://dhan.co/stocks/cholamandalam-investment-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACHOLAFIN",
    nsecode: "CHOLAFIN",
    bsecode: "511243",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE19257:CHOLAMANDALAM IN & FIN CO",
    atToken: "NSE_CHOLAFIN"
  },
  {
    name: "Life Insurance Corporation of India",
    url3: "https://dhan.co/stocks/lic-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALICI",
    nsecode: "LICI",
    bsecode: "543526",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE9480:LIC of India",
    atToken: "NSE_LICI"
  },
  {
    name: "SBI Cards & Payment Services Ltd",
    url3: "https://dhan.co/stocks/sbi-cards-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASBICARD",
    nsecode: "SBICARD",
    bsecode: "543066",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17971:SBI Cards",
    atToken: "NSE_SBICARD"
  },
  {
    name: "Icici Prudential Life Insurance Company Limited",
    url3: "https://dhan.co/stocks/icici-prudential-life-insurance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AICICIPRULI",
    nsecode: "ICICIPRULI",
    bsecode: "540133",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18652:ICICI Prudential Life Insurance",
    atToken: "NSE_ICICIPRULI"
  },
  {
    name: "HDFC Life Insurance Company Ltd",
    url3: "https://dhan.co/stocks/hdfc-life-insurance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHDFCLIFE",
    nsecode: "HDFCLIFE",
    bsecode: "540777",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE467:HDFC Life Insurance",
    atToken: "NSE_HDFCLIFE"
  },
  {
    name: "Housing and Urban Development Corporation",
    url3: "https://dhan.co/stocks/housing-urban-development-corporation-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHUDCO",
    nsecode: "HUDCO",
    bsecode: "540530",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE20825:HUDCO",
    atToken: "NSE_HUDCO"
  },
  {
    name: "Indian Railway Finance Corporation Ltd",
    url3: "https://dhan.co/stocks/indian-railway-finance-corp-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIRFC",
    nsecode: "IRFC",
    bsecode: "543257",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2029:IRFC",
    atToken: "NSE_IRFC"
  },
  {
    name: "L&T Finance Ltd",
    url3: "https://dhan.co/stocks/lt-finance-holdings-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALTF",
    nsecode: "LTF",
    bsecode: "533519",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE24948:L&T Finance",
    atToken: "NSE_LTF"
  },
  {
    name: "Page Industries Limited",
    url3: "https://dhan.co/stocks/page-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APAGEIND",
    nsecode: "PAGEIND",
    bsecode: "532827",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14413:Page Industries",
    atToken: "NSE_PAGEIND"
  },
  {
    name: "Trent Limited",
    url3: "https://dhan.co/stocks/trent-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATRENT",
    nsecode: "TRENT",
    bsecode: "500251",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1964:Trent",
    atToken: "NSE_TRENT"
  },
  {
    name: "Britannia Industries Limited",
    url3: "https://dhan.co/stocks/britannia-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABRITANNIA",
    nsecode: "BRITANNIA",
    bsecode: "500825",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE547:Britannia Industries",
    atToken: "NSE_BRITANNIA"
  },
  {
    name: "Supreme Industries Limited",
    url3: "https://dhan.co/stocks/supreme-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASUPREMEIND",
    nsecode: "SUPREMEIND",
    bsecode: "509930",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3363:Supreme Industries",
    atToken: "NSE_SUPREMEIND"
  },
  {
    name: "Hindustan Unilever Limited",
    url3: "https://dhan.co/stocks/hindustan-unilever-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHINDUNILVR",
    nsecode: "HINDUNILVR",
    bsecode: "500696",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1394:Hindustan Unilever",
    atToken: "NSE_HINDUNILVR"
  },
  {
    name: "Nestle India Limited",
    url3: "https://dhan.co/stocks/nestle-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANESTLEIND",
    nsecode: "NESTLEIND",
    bsecode: "500790",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17963:Nestle",
    atToken: "NSE_NESTLEIND"
  },
  {
    name: "United Breweries Limited",
    url3: "https://dhan.co/stocks/united-breweries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AUBL",
    nsecode: "UBL",
    bsecode: "532478",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE16713:United Breweries"
  },
  {
    name: "United Spirits Ltd",
    url3: "https://dhan.co/stocks/united-spirits-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AUNITDSPR",
    nsecode: "UNITDSPR",
    bsecode: "532432",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10447:United Spirits",
    atToken: "NSE_UNITDSPR"
  },
  {
    name: "Patanjali Foods Ltd",
    url3: "https://dhan.co/stocks/ruchi-soya-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APATANJALI",
    nsecode: "PATANJALI",
    bsecode: "500368",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17029:Patanjali Foods"
  },
  {
    name: "Bata India Limited",
    url3: "https://dhan.co/stocks/bata-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABATAINDIA",
    nsecode: "BATAINDIA",
    bsecode: "500043",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE371:Bata"
  },
  {
    name: "Jubilant Foodworks Limited",
    url3: "https://dhan.co/stocks/jubilant-foodworks-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AJUBLFOOD",
    nsecode: "JUBLFOOD",
    bsecode: "533155",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18096:Jubilant FoodWorks",
    atToken: "NSE_JUBLFOOD"
  },
  {
    name: "Marico Limited",
    url3: "https://dhan.co/stocks/marico-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMARICO",
    nsecode: "MARICO",
    bsecode: "531642",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4067:Marico",
    atToken: "NSE_MARICO"
  },
  {
    name: "Varun Beverages Limited",
    url3: "https://dhan.co/stocks/varun-beverages-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AVBL",
    nsecode: "VBL",
    bsecode: "540180",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18921:Varun Beverages",
    atToken: "NSE_VBL"
  },
  {
    name: "Dabur India Limited",
    url3: "https://dhan.co/stocks/dabur-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADABUR",
    nsecode: "DABUR",
    bsecode: "500096",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE772:Dabur",
    atToken: "NSE_DABUR"
  },
  {
    name: "Itc Limited",
    url3: "https://dhan.co/stocks/itc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AITC",
    nsecode: "ITC",
    bsecode: "500875",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1660:ITC",
    atToken: "NSE_ITC"
  },
  {
    name: "Avenue Supermarts",
    url3: "https://dhan.co/stocks/dmart-avenue-supermarts-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADMART",
    nsecode: "DMART",
    bsecode: "540376",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE19913:Avenue Supermarts DMart",
    atToken: "NSE_DMART"
  },
  {
    name: "Colgate Palmolive (india) Limited",
    url3: "https://dhan.co/stocks/colgate-palmolive-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACOLPAL",
    nsecode: "COLPAL",
    bsecode: "500830",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15141:Colgate Palmolive",
    atToken: "NSE_COLPAL"
  },
  {
    name: "Aditya Birla Fashion And Retail Limited",
    url3: "https://dhan.co/stocks/aditya-birla-fashion-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AABFRL",
    nsecode: "ABFRL",
    bsecode: "535755",
    sector: "FMCG",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE30108:Aditya Birla Fashion",
    atToken: "NSE_ABFRL"
  },
  {
    name: "Metropolis Healthcare Ltd",
    url3: "https://dhan.co/stocks/metropolis-healthcare-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMETROPOLIS",
    nsecode: "METROPOLIS",
    bsecode: "542650",
    sector: "HEALTHCARE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE9581:Metropolis Healthcare"
  },
  {
    name: "Max Healthcare Institute Ltd",
    url3: "https://dhan.co/stocks/max-healthcare-institute-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMAXHEALTH",
    nsecode: "MAXHEALTH",
    bsecode: "543220",
    sector: "HEALTHCARE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE22377:Max Healthcare Institute",
    atToken: "NSE_MAXHEALTH"
  },
  {
    name: "BANKNIFTY",
    url3: "https://dhan.co/indices/nifty-50-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABANKNIFTY",
    nsecode: "BANKNIFTY",
    bsecode: "",
    sector: "Indices",
    atToken: "BANKNIFTY"
  },
  {
    name: "NIFTY",
    url3: "https://dhan.co/indices/nifty-50-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANIFTY",
    nsecode: "NIFTY",
    bsecode: "",
    sector: "Indices",
    atToken: "NIFTY"
  },
  {
    name: "Polycab India Ltd",
    url3: "https://dhan.co/stocks/polycab-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APOLYCAB",
    nsecode: "POLYCAB",
    bsecode: "542652",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE9590:Polycab",
    atToken: "NSE_POLYCAB"
  },
  {
    name: "Siemens Limited",
    url3: "https://dhan.co/stocks/siemens-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASIEMENS",
    nsecode: "SIEMENS",
    bsecode: "500550",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3150:Siemens",
    atToken: "NSE_SIEMENS"
  },
  {
    name: "Kei Industries Limited",
    url3: "https://dhan.co/stocks/kei-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AKEI",
    nsecode: "KEI",
    bsecode: "517569",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13310:KEI Industries",
    atToken: "NSE_KEI"
  },
  {
    name: "Adani Enterprises Limited",
    url3: "https://dhan.co/stocks/adani-enterprises-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AADANIENT",
    nsecode: "ADANIENT",
    bsecode: "512599",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE25:Adani Enterprises",
    atToken: "NSE_ADANIENT"
  },
  {
    name: "Grasim Industries Limited",
    url3: "https://dhan.co/stocks/grasim-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGRASIM",
    nsecode: "GRASIM",
    bsecode: "500300",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1232:Grasim Industries",
    atToken: "NSE_GRASIM"
  },
  {
    name: "Bharat Forge Limited",
    url3: "https://dhan.co/stocks/bharat-forge-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABHARATFORG",
    nsecode: "BHARATFORG",
    bsecode: "500493",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE422:Bharat Forge",
    atToken: "NSE_BHARATFORG"
  },
  {
    name: "Container Corporation Of India Limited",
    url3: "https://dhan.co/stocks/container-corporation-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACONCOR",
    nsecode: "CONCOR",
    bsecode: "531344",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4749:Container Corporation of India",
    atToken: "NSE_CONCOR"
  },
  {
    name: "Delhivery Ltd",
    url3: "https://dhan.co/stocks/delhivery-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADELHIVERY",
    nsecode: "DELHIVERY",
    bsecode: "543529",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE9599:Delhivery",
    atToken: "NSE_DELHIVERY"
  },
  {
    name: "Bharat Electronics Limited",
    url3: "https://dhan.co/stocks/bharat-electronics-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABEL",
    nsecode: "BEL",
    bsecode: "500049",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE383:Bharat Electronics",
    atToken: "NSE_BEL"
  },
  {
    name: "Interglobe Aviation Limited",
    url3: "https://dhan.co/stocks/indigo-interglobe-aviation-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINDIGO",
    nsecode: "INDIGO",
    bsecode: "539448",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11195:Interglobe Aviation",
    atToken: "NSE_INDIGO"
  },
  {
    name: "Adani Ports And Special Economic Zone Limited",
    url3: "https://dhan.co/stocks/adani-ports-sez-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AADANIPORTS",
    nsecode: "ADANIPORTS",
    bsecode: "532921",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15083:Adani Ports & SEZ",
    atToken: "NSE_ADANIPORTS"
  },
  {
    name: "The Indian Hotels Company Limited",
    url3: "https://dhan.co/stocks/indian-hotels-company-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINDHOTEL",
    nsecode: "INDHOTEL",
    bsecode: "500850",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1512:Indian Hotels Company",
    atToken: "NSE_INDHOTEL"
  },
  {
    name: "Indian Railway Catering & Tourism Corporation Ltd",
    url3: "https://dhan.co/stocks/irctc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIRCTC",
    nsecode: "IRCTC",
    bsecode: "542830",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13611:IRCTC",
    atToken: "NSE_IRCTC"
  },
  {
    name: "Gujarat Narmada Valley Fertilizers And Chemicals Limited",
    url3: "https://dhan.co/stocks/gnfc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGNFC",
    nsecode: "GNFC",
    bsecode: "500670",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1174:Gujarat Narmada Valley Fert & Chem"
  },
  {
    name: "GMR Airports Ltd",
    url3: "https://dhan.co/stocks/gmr-infrastructure-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGMRAIRPORT",
    nsecode: "GMRAIRPORT",
    bsecode: "532754",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13528:GMR Airports Infrastructure",
    atToken: "NSE_GMRAIRPORT"
  },
  {
    name: "Computer Age Management Services Ltd",
    url3: "https://dhan.co/stocks/cams-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACAMS",
    nsecode: "CAMS",
    bsecode: "543232",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE342:Computer Age Management Services",
    atToken: "NSE_CAMS"
  },
  {
    name: "Oracle Financial Services Software Limited",
    url3: "https://dhan.co/stocks/oracle-financial-services-software-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AOFSS",
    nsecode: "OFSS",
    bsecode: "532466",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10738:Oracle Financial Services Software",
    atToken: "NSE_OFSS"
  },
  {
    name: "Coforge (Niit Tech)",
    url3: "https://dhan.co/stocks/coforge-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACOFORGE",
    nsecode: "COFORGE",
    bsecode: "532541",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11543:Coforge",
    atToken: "NSE_COFORGE"
  },
  {
    name: "Tata Elxsi Limited",
    url3: "https://dhan.co/stocks/tata-elxsi-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATAELXSI",
    nsecode: "TATAELXSI",
    bsecode: "500408",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3411:Tata Elxsi",
    atToken: "NSE_TATAELXSI"
  },
  {
    name: "Persistent Systems Limited",
    url3: "https://dhan.co/stocks/persistent-systems-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APERSISTENT",
    nsecode: "PERSISTENT",
    bsecode: "533179",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18365:Persistent Systems",
    atToken: "NSE_PERSISTENT"
  },
  {
    name: "LTI Mindtree Ltd",
    url3: "https://dhan.co/stocks/lti-mindtree-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALTIM",
    nsecode: "LTIM",
    bsecode: "540005",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17818:LTI Mindtree",
    atToken: "NSE_LTIM"
  },
  {
    name: "L&t Technology Services Limited",
    url3: "https://dhan.co/stocks/lt-technology-services-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALTTS",
    nsecode: "LTTS",
    bsecode: "540115",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18564:L&T Technology Services",
    atToken: "NSE_LTTS"
  },
  {
    name: "Mphasis Limited",
    url3: "https://dhan.co/stocks/mphasis-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMPHASIS",
    nsecode: "MPHASIS",
    bsecode: "526299",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4503:Mphasis",
    atToken: "NSE_MPHASIS"
  },
  {
    name: "Indiamart Intermesh Ltd",
    url3: "https://dhan.co/stocks/indiamart-intermesh-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINDIAMART",
    nsecode: "INDIAMART",
    bsecode: "542726",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10726:IndiaMART InterMesh"
  },
  {
    name: "Hcl Technologies Limited",
    url3: "https://dhan.co/stocks/hcl-technologies-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHCLTECH",
    nsecode: "HCLTECH",
    bsecode: "532281",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE7229:HCL Technologies",
    atToken: "NSE_HCLTECH"
  },
  {
    name: "Infosys Limited",
    url3: "https://dhan.co/stocks/infosys-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINFY",
    nsecode: "INFY",
    bsecode: "500209",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1594:Infosys",
    atToken: "NSE_INFY"
  },
  {
    name: "Cyient Limited",
    url3: "https://dhan.co/stocks/cyient-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACYIENT",
    nsecode: "CYIENT",
    bsecode: "532175",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE5748:Cyient",
    atToken: "NSE_CYIENT"
  },
  {
    name: "Tech Mahindra Limited",
    url3: "https://dhan.co/stocks/tech-mahindra-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATECHM",
    nsecode: "TECHM",
    bsecode: "532755",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13538:Tech Mahindra",
    atToken: "NSE_TECHM"
  },
  {
    name: "Tata Technologies Ltd",
    url3: "https://dhan.co/stocks/tata-technologies-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATATECH",
    nsecode: "TATATECH",
    bsecode: "544028",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE20293:Tata Technologies"
  },
  {
    name: "KPIT Technologies Ltd",
    url3: "https://dhan.co/stocks/kpit-technologies-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AKPITTECH",
    nsecode: "KPITTECH",
    bsecode: "542651",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE9683:KPIT Technologies",
    atToken: "NSE_KPITTECH"
  },
  {
    name: "Birlasoft Ltd",
    url3: "https://dhan.co/stocks/birlasoft-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABSOFT",
    nsecode: "BSOFT",
    bsecode: "532400",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE6994:Birlasoft",
    atToken: "NSE_BSOFT"
  },
  {
    name: "Wipro Limited",
    url3: "https://dhan.co/stocks/wipro-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AWIPRO",
    nsecode: "WIPRO",
    bsecode: "507685",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3787:Wipro",
    atToken: "NSE_WIPRO"
  },
  {
    name: "Zomato Ltd",
    url3: "https://dhan.co/stocks/zomato-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AZOMATO",
    nsecode: "ZOMATO",
    bsecode: "543320",
    sector: "IT"
  },
  {
    name: "Info Edge (india) Limited",
    url3: "https://dhan.co/stocks/naukri-info-edge-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANAUKRI",
    nsecode: "NAUKRI",
    bsecode: "532777",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13751:Info Edge",
    atToken: "NSE_NAUKRI"
  },
  {
    name: "Tata Consultancy Services Limited",
    url3: "https://dhan.co/stocks/tcs-tata-consultancy-services-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATCS",
    nsecode: "TCS",
    bsecode: "532540",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11536:Tata Consultancy Services",
    atToken: "NSE_TCS"
  },
  {
    name: "PB Fintech Ltd",
    url3: "https://dhan.co/stocks/policy-bazaar-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APOLICYBZR",
    nsecode: "POLICYBZR",
    bsecode: "543390",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE6656:PB FinTech",
    atToken: "NSE_POLICYBZR"
  },
  {
    name: "One 97 Communications Ltd",
    url3: "https://dhan.co/stocks/paytm-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APAYTM",
    nsecode: "PAYTM",
    bsecode: "543396",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE6705:One 97 Communications",
    atToken: "NSE_PAYTM"
  },
  {
    name: "FSN E-Commerce Ventures Ltd",
    url3: "https://dhan.co/stocks/nykaa-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANYKAA",
    nsecode: "NYKAA",
    bsecode: "543384",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE6545:Nykaa",
    atToken: "NSE_NYKAA"
  },
  {
    name: "Tata Communications Limited",
    url3: "https://dhan.co/stocks/tata-communications-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATACOMM",
    nsecode: "TATACOMM",
    bsecode: "500483",
    sector: "MEDIA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3721:Tata Communications",
    atToken: "NSE_TATACOMM"
  },
  {
    name: "Bharti Airtel Limited",
    url3: "https://dhan.co/stocks/bharti-airtel-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABHARTIARTL",
    nsecode: "BHARTIARTL",
    bsecode: "532454",
    sector: "MEDIA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10604:Bharti Airtel",
    atToken: "NSE_BHARTIARTL"
  },
  {
    name: "Sun Tv Network Limited",
    url3: "https://dhan.co/stocks/sun-tv-network-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASUNTV",
    nsecode: "SUNTV",
    bsecode: "532733",
    sector: "MEDIA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13404:Sun TV Network"
  },
  {
    name: "Himachal Futuristic Communications Limited",
    url3: "https://dhan.co/stocks/himachal-futuristic-communications-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHFCL",
    nsecode: "HFCL",
    bsecode: "500183",
    sector: "MEDIA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE21951:HFCL",
    atToken: "NSE_HFCL"
  },
  {
    name: "PVR Inox Ltd",
    url3: "https://dhan.co/stocks/pvr-cinemas-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APVRINOX",
    nsecode: "PVRINOX",
    bsecode: "532689",
    sector: "MEDIA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13147:PVR Inox"
  },
  {
    name: "Indus Towers Ltd (Bharti Infratel)",
    url3: "https://dhan.co/stocks/bharti-infratel-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINDUSTOWER",
    nsecode: "INDUSTOWER",
    bsecode: "534816",
    sector: "MEDIA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE29135:Indus Towers",
    atToken: "NSE_INDUSTOWER"
  },
  {
    name: "Idea Cellular Limited",
    url3: "https://dhan.co/stocks/vodafone-idea-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIDEA",
    nsecode: "IDEA",
    bsecode: "532822",
    sector: "MEDIA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14366:Vodafone Idea",
    atToken: "NSE_IDEA"
  },
  {
    name: "Apl Apollo Tubes Limited",
    url3: "https://dhan.co/stocks/apl-apollo-tubes-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAPLAPOLLO",
    nsecode: "APLAPOLLO",
    bsecode: "533758",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE25780:APL Apollo Tubes",
    atToken: "NSE_APLAPOLLO"
  },
  {
    name: "Jsw Steel Limited",
    url3: "https://dhan.co/stocks/jsw-steel-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AJSWSTEEL",
    nsecode: "JSWSTEEL",
    bsecode: "500228",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11723:JSW Steel",
    atToken: "NSE_JSWSTEEL"
  },
  {
    name: "Hindalco Industries Limited",
    url3: "https://dhan.co/stocks/hindalco-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHINDALCO",
    nsecode: "HINDALCO",
    bsecode: "500440",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1363:Hindalco Industries",
    atToken: "NSE_HINDALCO"
  },
  {
    name: "Vedanta Limited",
    url3: "https://dhan.co/stocks/vedanta-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AVEDL",
    nsecode: "VEDL",
    bsecode: "500295",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3063:Vedanta",
    atToken: "NSE_VEDL"
  },
  {
    name: "Coal India Limited",
    url3: "https://dhan.co/stocks/coal-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACOALINDIA",
    nsecode: "COALINDIA",
    bsecode: "533278",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE20374:Coal India",
    atToken: "NSE_COALINDIA"
  },
  {
    name: "Hindustan Copper Limited",
    url3: "https://dhan.co/stocks/hindustan-copper-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHINDCOPPER",
    nsecode: "HINDCOPPER",
    bsecode: "513599",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17939:Hindustan Copper",
    atToken: "NSE_HINDCOPPER"
  },
  {
    name: "National Aluminium Company Limited",
    url3: "https://dhan.co/stocks/national-aluminium-company-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANATIONALUM",
    nsecode: "NATIONALUM",
    bsecode: "532234",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE6364:NALCO",
    atToken: "NSE_NATIONALUM"
  },
  {
    name: "Tata Steel Limited",
    url3: "https://dhan.co/stocks/tata-steel-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATATASTEEL",
    nsecode: "TATASTEEL",
    bsecode: "500470",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3499:Tata Steel",
    atToken: "NSE_TATASTEEL"
  },
  {
    name: "Steel Authority Of India Limited",
    url3: "https://dhan.co/stocks/steel-authority-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASAIL",
    nsecode: "SAIL",
    bsecode: "500113",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2963:Steel Authority of India",
    atToken: "NSE_SAIL"
  },
  {
    name: "Nmdc Limited",
    url3: "https://dhan.co/stocks/nmdc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANMDC",
    nsecode: "NMDC",
    bsecode: "526371",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15332:NMDC",
    atToken: "NSE_NMDC"
  },
  {
    name: "Tube Investments of India Ltd",
    url3: "https://dhan.co/stocks/tube-invest-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATIINDIA",
    nsecode: "TIINDIA",
    bsecode: "540762",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE312:Tube Investment",
    atToken: "NSE_TIINDIA"
  },
  {
    name: "Jindal Steel & Power Limited",
    url3: "https://dhan.co/stocks/jindal-steel-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AJINDALSTEL",
    nsecode: "JINDALSTEL",
    bsecode: "532286",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE6733:Jindal Steel",
    atToken: "NSE_JINDALSTEL"
  },
  {
    name: "Kalyan Jewellers India Ltd",
    url3: "https://dhan.co/stocks/kalyan-jewellers-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AKALYANKJIL",
    nsecode: "KALYANKJIL",
    bsecode: "543278",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2955:Kalyan Jewellers",
    atToken: "NSE_KALYANKJIL"
  },
  {
    name: "Jindal Stainless Limited",
    url3: "https://dhan.co/stocks/jsl-jindal-stainless-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AJSL",
    nsecode: "JSL",
    bsecode: "532508",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11236:Jindal Stainless",
    atToken: "NSE_JSL"
  },
  {
    name: "Dixon Technologies",
    url3: "https://dhan.co/stocks/dixon-technologies-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADIXON",
    nsecode: "DIXON",
    bsecode: "540699",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE21690:Dixon Technologies",
    atToken: "NSE_DIXON"
  },
  {
    name: "Abb India Limited",
    url3: "https://dhan.co/stocks/abb-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AABB",
    nsecode: "ABB",
    bsecode: "500002",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13:ABB",
    atToken: "NSE_ABB"
  },
  {
    name: "Bharat Heavy Electricals Limited",
    url3: "https://dhan.co/stocks/bhel-bharat-heavy-electricals-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABHEL",
    nsecode: "BHEL",
    bsecode: "500103",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE438:Bharat Heavy Electricals",
    atToken: "NSE_BHEL"
  },
  {
    name: "Abbott India Limited",
    url3: "https://dhan.co/stocks/abbott-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AABBOTINDIA",
    nsecode: "ABBOTINDIA",
    bsecode: "500488",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17903:Abbott"
  },
  {
    name: "Atul Limited",
    url3: "https://dhan.co/stocks/atul-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AATUL",
    nsecode: "ATUL",
    bsecode: "500027",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE263:ATUL"
  },
  {
    name: "Divi's Laboratories Limited",
    url3: "https://dhan.co/stocks/divis-laboratories-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADIVISLAB",
    nsecode: "DIVISLAB",
    bsecode: "532488",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10940:Divis Laboratories",
    atToken: "NSE_DIVISLAB"
  },
  {
    name: "Alkem Laboratories Limited",
    url3: "https://dhan.co/stocks/alkem-laboratories-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AALKEM",
    nsecode: "ALKEM",
    bsecode: "539523",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11703:Alkem Laboratories",
    atToken: "NSE_ALKEM"
  },
  {
    name: "Pi Industries Limited",
    url3: "https://dhan.co/stocks/pi-industries-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APIIND",
    nsecode: "PIIND",
    bsecode: "523642",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE24184:PI Industries",
    atToken: "NSE_PIIND"
  },
  {
    name: "Torrent Pharmaceuticals Limited",
    url3: "https://dhan.co/stocks/torrent-pharmaceuticals-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ATORNTPHARM",
    nsecode: "TORNTPHARM",
    bsecode: "500420",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3518:Torrent Pharmaceuticals",
    atToken: "NSE_TORNTPHARM"
  },
  {
    name: "Navin Fluorine International Limited",
    url3: "https://dhan.co/stocks/navin-fluorine-international-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANAVINFLUOR",
    nsecode: "NAVINFLUOR",
    bsecode: "532504",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14672:Navin Fluorine International"
  },
  {
    name: "Deepak Nitrite Limited",
    url3: "https://dhan.co/stocks/deepak-nitrite-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADEEPAKNTR",
    nsecode: "DEEPAKNTR",
    bsecode: "506401",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE19943:Deepak Nitrite",
    atToken: "NSE_DEEPAKNTR"
  },
  {
    name: "Lupin Limited",
    url3: "https://dhan.co/stocks/lupin-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALUPIN",
    nsecode: "LUPIN",
    bsecode: "500257",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10440:Lupin",
    atToken: "NSE_LUPIN"
  },
  {
    name: "Ipca Laboratories Limited",
    url3: "https://dhan.co/stocks/ipca-laboratories-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIPCALAB",
    nsecode: "IPCALAB",
    bsecode: "524494",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1633:IPCA Laboratories"
  },
  {
    name: "Glenmark Pharmaceuticals Limited",
    url3: "https://dhan.co/stocks/glenmark-pharmaceuticals-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGLENMARK",
    nsecode: "GLENMARK",
    bsecode: "532296",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE7406:Glenmark Pharmaceuticals",
    atToken: "NSE_GLENMARK"
  },
  {
    name: "Cipla Limited",
    url3: "https://dhan.co/stocks/cipla-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACIPLA",
    nsecode: "CIPLA",
    bsecode: "500087",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE694:Cipla",
    atToken: "NSE_CIPLA"
  },
  {
    name: "Dr. Reddy's Laboratories Limited",
    url3: "https://dhan.co/stocks/dr-reddys-laboratories-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADRREDDY",
    nsecode: "DRREDDY",
    bsecode: "500124",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE881:Dr Reddys Laboratories",
    atToken: "NSE_DRREDDY"
  },
  {
    name: "Aurobindo Pharma Limited",
    url3: "https://dhan.co/stocks/aurobindo-pharma-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAUROPHARMA",
    nsecode: "AUROPHARMA",
    bsecode: "524804",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE275:Aurobindo Pharma",
    atToken: "NSE_AUROPHARMA"
  },
  {
    name: "Syngene International Limited",
    url3: "https://dhan.co/stocks/syngene-international-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASYNGENE",
    nsecode: "SYNGENE",
    bsecode: "539268",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10243:Syngene International",
    atToken: "NSE_SYNGENE"
  },
  {
    name: "Laurus Labs Limited",
    url3: "https://dhan.co/stocks/laurus-labs-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALaurusLABS",
    nsecode: "LAURUSLABS",
    bsecode: "540222",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE19234:Laurus Labs",
    atToken: "NSE_LAURUSLABS"
  },
  {
    name: "Granules India Limited",
    url3: "https://dhan.co/stocks/granules-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGranules",
    nsecode: "GRANULES",
    bsecode: "532482",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11872:Granules",
    atToken: "NSE_GRANULES"
  },
  {
    name: "Biocon Limited",
    url3: "https://dhan.co/stocks/biocon-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABIOCON",
    nsecode: "BIOCON",
    bsecode: "532523",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11373:Biocon",
    atToken: "NSE_BIOCON"
  },
  {
    name: "Apollo Hospitals Enterprise Limited",
    url3: "https://dhan.co/stocks/apollo-hospitals-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAPOLLOHOSP",
    nsecode: "APOLLOHOSP",
    bsecode: "508869",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE157:Apollo Hospitals",
    atToken: "NSE_APOLLOHOSP"
  },
  {
    name: "Dr. Lal Path Labs Ltd.",
    url3: "https://dhan.co/stocks/dr-lal-pathlabs-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALALPATHLAB",
    nsecode: "LALPATHLAB",
    bsecode: "539524",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11654:Dr. Lal Path Labs"
  },
  {
    name: "Sun Pharmaceuticals Industries Limited",
    url3: "https://dhan.co/stocks/sun-pharmaceutical-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASUNPHARMA",
    nsecode: "SUNPHARMA",
    bsecode: "524715",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3351:Sun Pharmaceutical",
    atToken: "NSE_SUNPHARMA"
  },
  {
    name: "Zydus Lifesciences Ltd",
    url3: "https://dhan.co/stocks/cadila-healthcare-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AZYDUSLIFE",
    nsecode: "ZYDUSLIFE",
    bsecode: "532321",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE7929:Zydus Life Science",
    atToken: "NSE_ZYDUSLIFE"
  },
  {
    name: "State Bank Of India",
    url3: "https://dhan.co/stocks/state-bank-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ASBIN",
    nsecode: "SBIN",
    bsecode: "500112",
    sector: "PSUBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3045:State Bank of India",
    atToken: "NSE_SBIN"
  },
  {
    name: "Indian Bank",
    url3: "https://dhan.co/stocks/indian-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINDIANB",
    nsecode: "INDIANB",
    bsecode: "532814",
    sector: "PSUBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14309:Indian Bank",
    atToken: "NSE_INDIANB"
  },
  {
    name: "Bank Of Baroda",
    url3: "https://dhan.co/stocks/bank-of-baroda-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABANKBARODA",
    nsecode: "BANKBARODA",
    bsecode: "532134",
    sector: "PSUBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4668:Bank of Baroda",
    atToken: "NSE_BANKBARODA"
  },
  {
    name: "Union Bank Of India",
    url3: "https://dhan.co/stocks/union-bank-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AUNIONBANK",
    nsecode: "UNIONBANK",
    bsecode: "532477",
    sector: "PSUBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10753:Union Bank of India",
    atToken: "NSE_UNIONBANK"
  },
  {
    name: "Punjab National Bank",
    url3: "https://dhan.co/stocks/punjab-national-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APNB",
    nsecode: "PNB",
    bsecode: "532461",
    sector: "PSUBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10666:Punjab National Bank",
    atToken: "NSE_PNB"
  },
  {
    name: "Bank Of India",
    url3: "https://dhan.co/stocks/bank-of-india-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABANKINDIA",
    nsecode: "BANKINDIA",
    bsecode: "532149",
    sector: "PSUBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4745:Bank of India",
    atToken: "NSE_BANKINDIA"
  },
  {
    name: "Canara Bank",
    url3: "https://dhan.co/stocks/canara-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACANBK",
    nsecode: "CANBK",
    bsecode: "532483",
    sector: "PSUBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE10794:Canara Bank",
    atToken: "NSE_CANBK"
  },
  {
    name: "Kotak Mahindra Bank Limited",
    url3: "https://dhan.co/stocks/kotak-mahindra-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AKOTAKBANK",
    nsecode: "KOTAKBANK",
    bsecode: "500247",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1922:Kotak Bank",
    atToken: "NSE_KOTAKBANK"
  },
  {
    name: "Hdfc Bank Limited",
    url3: "https://dhan.co/stocks/hdfc-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHDFCBANK",
    nsecode: "HDFCBANK",
    bsecode: "500180",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1333:HDFC Bank",
    atToken: "NSE_HDFCBANK"
  },
  {
    name: "Icici Bank Limited",
    url3: "https://dhan.co/stocks/icici-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AICICIBANK",
    nsecode: "ICICIBANK",
    bsecode: "532174",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE4963:ICICI Bank",
    atToken: "NSE_ICICIBANK"
  },
  {
    name: "Axis Bank Limited",
    url3: "https://dhan.co/stocks/axis-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAXISBANK",
    nsecode: "AXISBANK",
    bsecode: "532215",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE5900:Axis Bank",
    atToken: "NSE_AXISBANK"
  },
  {
    name: "Indusind Bank Limited",
    url3: "https://dhan.co/stocks/indusind-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINDUSINDBK",
    nsecode: "INDUSINDBK",
    bsecode: "532187",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE5258:Indusind Bank",
    atToken: "NSE_INDUSINDBK"
  },
  {
    name: "AU Small Finance Bank",
    url3: "https://dhan.co/stocks/au-small-finance-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAUBANK",
    nsecode: "AUBANK",
    bsecode: "540611",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE21238:AU Small Finance Bank",
    atToken: "NSE_AUBANK"
  },
  {
    name: "City Union Bank Limited",
    url3: "https://dhan.co/stocks/city-union-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ACUB",
    nsecode: "CUB",
    bsecode: "532210",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE5701:City Union Bank"
  },
  {
    name: "Rbl Bank Limited",
    url3: "https://dhan.co/stocks/rbl-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ARBLBANK",
    nsecode: "RBLBANK",
    bsecode: "540065",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18391:RBL Bank",
    atToken: "NSE_RBLBANK"
  },
  {
    name: "Bandhan Bank Ltd",
    url3: "https://dhan.co/stocks/bandhan-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABANDHANBNK",
    nsecode: "BANDHANBNK",
    bsecode: "541153",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2263:Bandhan Bank",
    atToken: "NSE_BANDHANBNK"
  },
  {
    name: "IDFC First Bank Ltd",
    url3: "https://dhan.co/stocks/idfc-first-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIDFCFIRSTB",
    nsecode: "IDFCFIRSTB",
    bsecode: "539437",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11184:IDFC First Bank",
    atToken: "NSE_IDFCFIRSTB"
  },
  {
    name: "Yes Bank Limited",
    url3: "https://dhan.co/stocks/yes-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AYESBANK",
    nsecode: "YESBANK",
    bsecode: "532648",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11915:Yes Bank",
    atToken: "NSE_YESBANK"
  },
  {
    name: "The Federal Bank  Limited",
    url3: "https://dhan.co/stocks/federal-bank-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AFEDERALBNK",
    nsecode: "FEDERALBNK",
    bsecode: "500469",
    sector: "PVTBANK",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1023:Federal Bank",
    atToken: "NSE_FEDERALBNK"
  },
  {
    name: "Godrej Properties Limited",
    url3: "https://dhan.co/stocks/godrej-properties-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AGODREJPROP",
    nsecode: "GODREJPROP",
    bsecode: "533150",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE17875:Godrej Properties",
    atToken: "NSE_GODREJPROP"
  },
  {
    name: "Oberoi Realty Limited",
    url3: "https://dhan.co/stocks/oberoi-realty-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AOBEROIRLTY",
    nsecode: "OBEROIRLTY",
    bsecode: "533273",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE20242:Oberoi Realty",
    atToken: "NSE_OBEROIRLTY"
  },
  {
    name: "Nbcc (india) Limited",
    url3: "https://dhan.co/stocks/nbcc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANBCC",
    nsecode: "NBCC",
    bsecode: "534309",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE31415:NBCC"
  },
  {
    name: "The Phoenix Mills Limited",
    url3: "https://dhan.co/stocks/phoenix-mills-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APHOENIXLTD",
    nsecode: "PHOENIXLTD",
    bsecode: "503100",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14552:Phoenix Mills"
  },
  {
    name: "Macrotech Developers Ltd",
    url3: "https://dhan.co/stocks/macrotech-developers-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALODHA",
    nsecode: "LODHA",
    bsecode: "543287",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE3220:Macrotech Developers",
    atToken: "NSE_LODHA"
  },
  {
    name: "Dlf Limited",
    url3: "https://dhan.co/stocks/dlf-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ADLF",
    nsecode: "DLF",
    bsecode: "532868",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14732:DLF",
    atToken: "NSE_DLF"
  },
  {
    name: "Irb Infrastructure Developers Limited",
    url3: "https://dhan.co/stocks/irb-infrastructure-developers-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AIRB",
    nsecode: "IRB",
    bsecode: "532947",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15313:IRB Infrastructure Developers",
    atToken: "NSE_IRB"
  },
  {
    name: "Larsen & Toubro Limited",
    url3: "https://dhan.co/stocks/lt-larsen-toubro-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ALT",
    nsecode: "LT",
    bsecode: "500510",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11483:Larsen & Toubro",
    atToken: "NSE_LT"
  },
  {
    name: "Prestige Estates Projects Limited",
    url3: "https://dhan.co/stocks/prestige-estate-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APRESTIGE",
    nsecode: "PRESTIGE",
    bsecode: "533274",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE20302:Prestige Estate",
    atToken: "NSE_PRESTIGE"
  },
  {
    name: "Ncc Limited",
    url3: "https://dhan.co/stocks/ncc-nagarjuna-construction-company-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANCC",
    nsecode: "NCC",
    bsecode: "500294",
    sector: "REALTY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2319:NCC",
    atToken: "NSE_NCC"
  },
  {
    name: "Pnb Housing Finance Limited",
    url3: "https://dhan.co/stocks/pnb-housing-finance-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APNBHOUSING",
    nsecode: "PNBHOUSING",
    bsecode: "540173",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18908:PNB Housing Finance"
  },
  {
    name: "Hindustan Zinc Limited",
    url3: "https://dhan.co/stocks/hindustan-zinc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AHINDZINC",
    nsecode: "HINDZINC",
    bsecode: "500188",
    sector: "METAL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE1424:Hindustan Zinc"
  },
  {
    name: "Inox Wind Limited",
    url3: "https://dhan.co/stocks/hindustan-zinc-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AINOXWIND",
    nsecode: "INOXWIND",
    bsecode: "539083",
    sector: "ENERGY",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE7852:Inox Wind"
  },
  {
    name: "Eternal Ltd",
    url3: "https://dhan.co/stocks/eternal-ltd-share-price/",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AETERNAL",
    nsecode: "ETERNAL",
    bsecode: "543320",
    sector: "IT",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE5097:Eternal",
    atToken: "NSE_ZOMATO"
  },
  {
    name: "Bharat Dynamics Ltd",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABDL",
    bsecode: "541143",
    nsecode: "BDL",
    sector: "DEFENCE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE2144:Bharat Dynamics"
  },
  {
    name: "Mazagon Dock Shipbuilders Ltd",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMAZDOCK",
    sector: "DEFENCE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE509:Mazagon Dock Shipbuilders",
    bsecode: "543237",
    nsecode: "MAZDOCK"
  },
  {
    name: "Blue Star Limited",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ABLUESTARCO",
    bsecode: "500067",
    nsecode: "BLUESTARCO",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE8311:Blue Star"
  },
  {
    name: "Piramal Pharma Ltd",
    bsecode: "543635",
    nsecode: "PPLPHARMA",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3APPLPHARMA",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE11571:Piramal Pharma"
  },
  {
    name: "Kaynes Technology India Ltd",
    bsecode: "535493",
    nsecode: "KAYNES",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AKAYNES",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE12092:Kaynes Technology"
  },
  {
    name: "Rail Vikas Nigam Ltd",
    bsecode: "542649",
    nsecode: "RVNL",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ARVNL",
    sector: "INFRA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE9552:Rail Vikas Nigam"
  },
  {
    name: "Uno Minda Ltd",
    bsecode: "532539",
    nsecode: "UNOMINDA",
    url: "https://www.tradingview.com/chart/?symbol=NSE%3AUNOMINDA",
    sector: "AUTO",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14154:UNO Minda"
  },
  {
    name: "Fortis Healthcare Limited",
    bsecode: "532843",
    nsecode: "FORTIS",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AFORTIS",
    sector: "HEALTHCARE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE14592:Fortis Healthcare"
  },
  {
    name: "Mankind Pharma Ltd",
    bsecode: "543904",
    nsecode: "MANKIND",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AMANKIND",
    sector: "PHARMA",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15380:Mankind Pharma"
  },
  {
    name: "KFin Technologies Ltd",
    bsecode: "543720",
    nsecode: "KFINTECH",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AKFINTECH",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13359:KFin Technologies"
  },
  {
    name: "360 ONE WAM Ltd",
    bsecode: "542772",
    nsecode: "360ONE",
    url: "https://www.tradingview.com/chart/?symbol=NSE%3A360ONE",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE13061:360 One WAM"
  },
  {
    name: "Pg Electroplast Limited",
    bsecode: "533581",
    nsecode: "PGEL",
    url: "https://www.tradingview.com/chart/?symbol=NSE%3APGEL",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE25358:PG Electroplast"
  },
  {
    name: "Amber Enterprises India Ltd",
    bsecode: "540902",
    nsecode: "AMBER",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3AAMBER",
    sector: "CONSURDURBL",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE15380:Amber Enterprises"
  },
  {
    name: "Nuvama Wealth Management Ltd",
    bsecode: "543988",
    nsecode: "NUVAMA",
    url: "https://in.tradingview.com/chart/?symbol=NSE%3ANUVAMA",
    sector: "FINSERVICE",
    dhanUrl: "https://tv.dhan.co/?token_id=123GOFREE&?symbol=NSEE18721:Nuvama Wealth Management",
    atToken: "NSE_NUVAMA"
  }
]

